import api from "../../service/api";
export const GetNotificationCount = async() => {
    let path = 'common/notification-count/';
    return api.get(path);
}

export const GetNotificationList = async() => {
    let path = 'common/notifications/';
    return api.get(path);
}

export const GetMarkAsViewed = async(id) => {
    let path = `common/notification/mark-viewed/${id}`;
    return api.patch(path,{})
}
